import React, { useEffect, useContext, useRef, useState } from "react";
import { Portfolio } from "./component/Portfolio";
import { Experience } from "./component/Experience";
import { Contact } from "./component/Contact";
import { Footer } from "./component/Footer";
import { Header } from "./component/Header";
import { Home } from "./component/Home";
import { Skills } from "./component/Skills";
import { themeContext } from "./context";
import { motion, AnimatePresence } from "framer-motion";
import LoadingScreen from "./widget/LoadingScreen";
import "./index.css";
import BackButton from "./widget/backButton";
import { colors } from "./constants/colors";

export default function Main() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.title = "Makite Desta | Full-Stack Software Developer";
    const timer = setTimeout(() => setIsLoading(false), 2200);
    return () => clearTimeout(timer);
  }, []);

  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  useEffect(() => {
    document.body.classList.toggle("light-mode", !darkMode);
    return () => document.body.classList.remove("light-mode");
  }, [darkMode]);

  const sectionVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    hover: { scale: 1.01, transition: { duration: 0.2 } },
  };

  const homeRef = useRef(null);
  const portfolioRef = useRef(null);
  const skillsRef = useRef(null);
  const experienceRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <LoadingScreen />
      <AnimatePresence>
        {!isLoading && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
            className="App"
            style={{
              background: darkMode ? "#071423" : "#edf1f3",
              color: darkMode ? "#e2e8f0" : colors.primary,
              transition: "all 0.35s ease",
            }}
          >
            <div
              className="main-container"
              style={{
                background: darkMode ? colors.secondary : "#f4f6f8",
                color: darkMode ? "#e2e8f0" : colors.primary,
                position: "relative",
                overflowX: "hidden",
                overflowY: "visible",
                transition: "all 0.35s ease",
              }}
            >
              <Header
                scrollToSection={scrollToSection}
                refs={{
                  homeRef,
                  portfolioRef,
                  skillsRef,
                  experienceRef,
                  contactRef,
                }}
              />
              <motion.div
                ref={homeRef}
                variants={sectionVariants}
                initial="hidden"
                whileInView="visible"
                whileHover="hover"
                viewport={{ once: true }}
              >
                <Home />
              </motion.div>
              <motion.div
                ref={skillsRef}
                variants={sectionVariants}
                initial="hidden"
                whileInView="visible"
                whileHover="hover"
                viewport={{ once: true }}
              >
                <Skills />
              </motion.div>
              <motion.div
                ref={experienceRef}
                variants={sectionVariants}
                initial="hidden"
                whileInView="visible"
                whileHover="hover"
                viewport={{ once: true }}
              >
                <Experience />
              </motion.div>
              <motion.div
                ref={portfolioRef}
                variants={sectionVariants}
                initial="hidden"
                whileInView="visible"
                whileHover="hover"
                viewport={{ once: true }}
              >
                <Portfolio />
              </motion.div>
              <motion.div
                ref={contactRef}
                variants={sectionVariants}
                initial="hidden"
                whileInView="visible"
                whileHover="hover"
                viewport={{ once: true }}
              >
                <Contact />
              </motion.div>
              <Footer />
              <BackButton />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
